import React from 'react'

export const TaskBanner = props => (
    <div className={"title-container"}>
 <h4 className={"text2"} > Hello {props.userName}! You have this tasks to do today!</h4>
 
    </div>
   
) 